
<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="签到成功"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="signOk">
        <div class="img">
          <img src="../../assets/imgs/signInOk.png" alt="" />
        </div>
        <span class="title">{{h5Config.textCfg.signInText}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {

    }
  },
  mounted () {

  },
  computed: {
    ...mapGetters([
      'h5Config'
    ])
  },
  methods: {
    onClickLeft () {
      this.$router.replace('/order')
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  padding: 1rem;
}
.signOk {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
}
.img {
  width: 13.4375rem;
  height: 11.5625rem;
}
.img img {
  width: 100%;
  height: 100%;
}
.title {
  margin-top: 2rem;
}
</style>
